function monitor() {
	const elId = '#app-monitor';
	const elClass = '.js-vue-monitor';

	if ($(elId).length == 0 || $(elClass).length == 0) {
		return;
	}

	const headerHandicap = 1;
	const app = new Vue({
		el: elId,
		data: {
			mongo: {},
			rabbit: [],
			elastic: [],
			elasticLog: {},
			elasticData: {},
			error: null
		},
		created: function() {
			this.fetchData();
			$(elClass).removeClass('is-creating');
		},
		mounted: function() {
			$(elClass).removeClass('is-mounting');
		},
		methods: {
			fetchData: function() {
				const self = this;
				GET('/auth/mongomonitor').then(xhr => {
					self.mongo = JSON.parse(xhr.responseText);
				}, trapError);

				// 3 nodes
				for (let i = 1; i <= 3; i++) {
					const cur = i;
					GET(`/auth/elasticmonitor?index=${i}`).then(xhr => {
						const index = parseInt(xhr.responseURL.substring(xhr.responseURL.length - 1));
						Vue.set(self.elastic, index - 1, JSON.parse(xhr.responseText));
					});
					GET(`/auth/rabbitmonitor?index=${i}`).then(xhr => {
						const index = parseInt(xhr.responseURL.substring(xhr.responseURL.length - 1));
						Vue.set(self.rabbit, index - 1, JSON.parse(xhr.responseText));
					});
				}
				POST('/baas/nominow_management/elasticsearchlogstash', { search: '{"size":1,"query":{"bool":{"must":[{"range":{"@timestamp":{"gt":"now-1m"}}}]}}}' }).then(xhr => {
					self.elasticLog = JSON.parse(xhr.responseText);
				});
				POST('/baas/nominow_management/elasticsearchdatastash', { search: '{"size":1,"query":{"bool":{"must":[{"range":{"@timestamp":{"gt":"now-10m"}}}]}}}' }).then(xhr => {
					self.elasticData = JSON.parse(xhr.responseText);
				});
			},
			AnyOK: function(arr, key, value) {
				for (let i = 0; i < arr.length; i++) {
					if (arr[i] && arr[i][key] == value) return true;
				}
				return false;
			}
		}
	});
	/* App is added as window.activeRootComponent so that it can be used by helpers, such as the keyup helper. */
	window.activeRootComponent = app;
}
monitor();
